module.exports = __webpack_public_path__ + "img/avatar0.35e007fa.png";